import type {
  CreateTaxAddressResponse,
  EditTaxAddressResponse,
  taxAddressReq
} from "@/features/register/types";
import { useMutation } from "@tanstack/react-query";
import { TaxAddressApiClient } from "../api-client/api-client";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";

export const useTaxAddress = () => {
  const { leUuid } = useCompanyContext();
  const createUserAddressTaxMutation = () =>
    useMutation<CreateTaxAddressResponse | null, Error, taxAddressReq>({
      mutationFn: async (taxAddress) => {
        return await TaxAddressApiClient.create(taxAddress, leUuid ?? undefined);
      }
    });

  const updateUserAddressTaxMutation = () =>
    useMutation<EditTaxAddressResponse | null, Error, taxAddressReq>({
      mutationFn: async (taxAddress) => {
        return await TaxAddressApiClient.update(taxAddress, leUuid ?? undefined);
      }
    });
  return {
    createAddressTaxMutation: createUserAddressTaxMutation,
    updateUserAddressTaxMutation: updateUserAddressTaxMutation
  };
};
